import Layer from "./layer";
import Node from "./node";
import Connection from '@/components/whiteboard/connection';

class Project {
    version = '0.0.1';
    layers;
    activeLayer;
    layerNamePrefix = 'layer';
    mode;

    constructor(json) {
        this.setMode(Project.MODE_DEFAULT);
        this.layers = [];

        if (json) {
            this.load(json)
        } else {
            this.init();
        }
    }

    init() {
        this.layers.push(new Layer(this.layerNamePrefix + ' 1', this));
        this.layers[0].activate();
    }

    load(json) {
        for (let i = 0; i < json.layers.length; i++) {
            let layer = new Layer(json.layers[i], this);

            this.layers.push(layer);

            if (layer.name === json.activeLayer) {
                layer.activate();
            }
        }
    }

    createLayer(name) {
        if (name === undefined) {
            name = this.generateLayerName();
        }

        let layer = new Layer(name, this);
        this.layers.push(layer);
        this.activateLayer(layer);
    }

    generateLayerName() {
        let name;

        name:
            for (let n = 1; true; n++) {
                name = this.layerNamePrefix + ' ' + n;

                for (let i = 0; i < this.layers.length; i++) {
                    if (this.layers[i].name === name) {
                        continue name;
                    }
                }

                break;
            }

        return name;
    }

    activateLayer(layer) {
        if (this.activeLayer) {
            this.activeLayer.deactivate();
        }

        layer.activate();
    }

    createNode(coordinates) {
        return new Node(this.activeLayer, coordinates);
    }

    createConnection(coordinates) {
        return new Connection(this.activeLayer, coordinates);
    }

    toSerializable() {
        let o = {
            version: this.version,
            activeLayer: this.activeLayer.name,
            layers: []
        };

        for (let i = 0; i < this.layers.length; i++) {
            o.layers.push(this.layers[i].toSerializable());
        }

        return o;
    }

    deleteLayer(layer) {
        layer.destroy();

        this.layers.splice(this.layers.indexOf(layer), 1);

        if (this.activeLayer === layer) {
            this.activateLayer(this.layers[0]);
        }
    }

    setMode(mode) {
        this.mode = mode;
    }
}

Project.MODE_DEFAULT = 0;
Project.MODE_RECTANGLE = 1;
Project.MODE_CONNECTION = 2;

export default Project;
